<script>
import axios from "axios";
import BaseInput from "./Base/BaseInput3.vue";
import Textarea from "./Base/BaseTextarea.vue";
import DataInputSimple from "./Base/DataInputSimple2";
import TinymceEditor from "./Base/TinymceEditor3";
import BasePdfUploader from "@/components/Base/BasePdfCompetitionUploader.vue";
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import {Spin, Button, Select, SelectOption, Table, Upload, Checkbox} from "ant-design-vue";
import SaveInfo from "@/components/Base/SaveInfo.vue";
import {Field, Form} from 'vee-validate';

import Json from '@/services/json'
import ImageService from "@/services/ImageService";
import ImageRender from "@/components/Base/ImageRender.vue";
import VideoRender from "@/components/Base/VideoRender.vue";
import ExportCompetition from './ExportCompetition.vue'
import CompetitionUploadPriceTable from "@/components/Components/CompetitionUploadPriceTable.vue";

const competitionData = {
	video_code: '',
	is_bussines_area: false,
	isClose: false,
	leadToProject: false,
};

export default {
	components: {
		ImageRender,
		SaveInfo,
		Spin,
		BaseInput,
		Textarea,
		DataInputSimple,
		VueCropper,
		TinymceEditor,
		BasePdfUploader,
		Button,
		Field,
		Form,
		Select,
		SelectOption,
		Table,
		Upload,
		Checkbox,
		VideoRender,
		ExportCompetition,
		CompetitionUploadPriceTable
	},
	data() {
		return {
			imgSrc: '',
			imgSrcBig: '',
			loading: false,
			isDataUpdating: false,
			competition: null,
			companies: [],
			products: [],
			selectedProduct: null,
			company: '',
			buttons: [],
			question_text: '',
			answer_text: '',
			expert_fio: '',
			expert_dolzhnost: '',
			imgSrcExpert: '',
			origfilename: '',
			origfilenameBig: '',
			origfilenameExpert: '',
			company_columns: [
				{
					title: 'Название',
					dataIndex: 'firm_name',
					key: 'firm_name',
				},
				{
					title: 'Действия',
					dataIndex: 'action',
					key: 'action',
				},
			],
			current_qa_id: '',
			fullErrors: false
		}
	},
	async created() {
		this.loading = true;
		await this.get_current_competition();
		// if (this.isBussinessArea) {}
		await this.getCompanies();
		await this.getProducts();
		this.loading = false;
	},
	methods: {
		async getData() {
			this.isDataUpdating = true;
			await this.get_current_competition();
			this.isDataUpdating = false;
		},
		async delete_competition_slide(item) {
			await axios.post('/competition/delete_competition_slide/' + this.competition.id, null, {
				params: {
					filename: item
				}
			});
			this.getData()
		},
		async getCompanies() {
			const response = await axios.get('/get_film_companies');
			this.companies = response.data;
		},
		async getProducts() {
			const response = await axios.get('/api/products');
			this.products = response.data['hydra:member'] || response.data;
		},
		async addCompany() {
			if (!this.competition?.competitionData?.film_companies) {
				this.competition.competitionData.film_companies = [];
			}
			if (!this.competition?.competitionData?.film_companies.includes(this.company)) {
				this.competition.competitionData.film_companies.push(this.company);
			}
			this.company = '';
			this.saveData();
		},
		deleteCompanyItem(id) {
			let index = this.competition.competitionData.film_companies.indexOf(id);
			
			if (index !== -1) {
				this.competition.competitionData.film_companies.splice(index, 1);
			}
			this.saveData();
		},
		selectProduct() {
			if (this.selectedProduct) {
				// Устанавливаем связь с товаром через API Platform IRI
				this.competition.product = '/api/products/' + this.selectedProduct;
			} else {
				this.competition.product = null;
			}
			this.saveData();
		},
		async get_current_competition() {
			const response = await axios.get('/api/competitions/' + this.competitionId + '.json');
			response.data.competitionData = Json.handle_json_field(response.data.competitionData, competitionData);
			this.competition = response.data;
			if (this.competition.product) {
				// Если product это строка IRI, извлекаем ID
				if (typeof this.competition.product === 'string') {
					const productId = this.competition.product.split('/').pop();
					this.selectedProduct = parseInt(productId);
				} else {
					// Если product это объект
					this.selectedProduct = this.competition.product.id;
				}
			} else {
				this.selectedProduct = null;
			}
		},
		isFieldRequired(fieldName) {
			return false;
		},
		setImage(e) {
			const self = this;
			const file = e.target.files[0];
			if (!file.type.includes("image/")) {
				alert("Загрузить можно только изображение");
				return;
			}
			if (file.size > 1572864) {
				alert("Максимальный размер изображения 1,5 мегабайта. Обработайте изображение в графических редакторах, чтобы уменьшить его размер.");
				return;
			}
			this.origfilename = file.name;
			
			if (typeof FileReader === "function") {
				const reader = new FileReader();
				reader.onload = event => {
					self.imgSrc = event.target.result;
					if (self.$refs.cropper) {
						self.$refs.cropper.replace(event.target.result);
					}
				};
				reader.readAsDataURL(file);
			} else {
				alert("Sorry, FileReader API not supported");
			}
		},
		setImageBig(e) {
			const self = this;
			const file = e.target.files[0];
			if (!file.type.includes("image/") && file.type !== "video/mp4") {
				alert("Загрузить можно только изображение или видео в формате MP4");
				return;
			}
			if (file.size > 31457280) {
				alert("Максимальный размер файла 30 мегабайт. Обработайте файл, чтобы уменьшить его размер.");
				return;
			}
			this.origfilenameBig = file.name;
			if (file.type === "video/mp4") {
				const file = event.target.files[0];
				//const blob = new Blob([file], { type: "video/mp4" });
				
				let formData = new FormData();
				formData.append('file', file);
				formData.append('original-name', self.origfilenameBig);
				formData.append('current-name', self.competition.imageBig);
				formData.append('object-key', 'imageBig');
				
				formData.append('entity-id', self.competition.id);
				
				axios(
					{
						method: 'post',
						url: '/competition/setAvatar',
						data: formData
					}
				)
					.then(() => {
						self.imgSrc = '';
						self.getData();
					});
			} else {
				if (typeof FileReader === "function") {
					const reader = new FileReader();
					reader.onload = event => {
						self.imgSrcBig = event.target.result;
						if (self.$refs.cropperBig) {
							self.$refs.cropperBig.replace(event.target.result);
						}
					};
					reader.readAsDataURL(file);
				} else {
					alert("Sorry, FileReader API not supported");
				}
			}
			
		},
		cropImage() {
			const self = this;
			this.$refs.cropper.getCroppedCanvas('getCroppedCanvas').toBlob(function (blob) {
				let formData = new FormData();
				formData.append('file', blob);
				formData.append('original-name', self.origfilename);
				formData.append('current-name', self.competition.avatar);
				formData.append('entity-id', self.competition.id);
				
				axios(
					{
						method: 'post',
						url: '/competition/setAvatar',
						data: formData
					}
				)
					.then(() => {
						self.imgSrc = '';
						self.getData();
					});
			})
		},
		cropImageBig() {
			const self = this;
			this.$refs.cropperBig.getCroppedCanvas('getCroppedCanvas').toBlob(function (blob) {
				let formData = new FormData();
				formData.append('file', blob);
				formData.append('original-name', self.origfilenameBig);
				formData.append('current-name', self.competition.imageBig);
				formData.append('object-key', 'imageBig');
				
				formData.append('entity-id', self.competition.id);
				
				axios(
					{
						method: 'post',
						url: '/competition/setAvatar',
						data: formData
					}
				)
					.then(() => {
						self.imgSrcBig = '';
						self.getData();
					});
			})
		},
		isRequired(value) {
			if (value === null) {
				return false;
			}
			if (Array.isArray(value)) {
				return value && value.length > 0;
			} else if (typeof value === 'string') {
				return value && value.trim().length > 0;
			} else if (typeof value === 'boolean') {
				return value;
			} else {
				return false;
			}
		},
		setImageExpert(e) {
			const self = this;
			const file = e.target.files[0];
			if (!file.type.includes("image/")) {
				alert("Загрузить можно только изображение");
				return;
			}
			if (file.size > 1572864) {
				alert("Максимальный размер изображения 1,5 мегабайта. Обработайте изображение в графических редакторах, чтобы уменьшить его размер.");
				return;
			}
			this.origfilenameExpert = file.name;
			
			if (typeof FileReader === "function") {
				const reader = new FileReader();
				reader.onload = event => {
					self.imgSrcExpert = event.target.result;
					// rebuild cropperjs with the updated source
					if (self.$refs.cropper_expert) {
						self.$refs.cropper_expert.replace(event.target.result);
					}
				};
				reader.readAsDataURL(file);
			} else {
				alert("Sorry, FileReader API not supported");
			}
		},
		saveExpert(e) {
			if (this.imgSrcExpert.length > 0 && this.expert_fio.length > 0 && this.expert_dolzhnost.length > 0) {
				// $('.image_button_expert').html('<div class="loader"></div>');
				
				const self = this;
				
				this.$refs.cropper_expert.getCroppedCanvas('getCroppedCanvas').toBlob(function (blob) {
					
					let formData = new FormData();
					formData.append('file', blob);
					formData.append('original-name', self.origfilenameExpert);
					formData.append('current-name', '');
					formData.append('expert_fio', self.expert_fio);
					formData.append('expert_dolzhnost', self.expert_dolzhnost);
					formData.append('competition-id', self.competition.id);
					formData.append('entity-id', '');
					
					axios(
						{
							method: 'post',
							url: '/competition/addExpertLanding',
							data: formData
						}
					)
						.then((response) => {
							//console.log(response);
							if (response.data.length > 0) {
								//console.log(response.data);
								//$('#competition_newFileName').val(response.data);
								//$('#competition_form').submit();
							}
						});
					
					
				})
			}
		},
		onStageChange() {
			if (!this.isBussinessArea) {
				if (this.competition.stage.length > 0 && this.competition.stage !== 'Завершен') {
					this.fullErrors = true;
				} else {
					this.fullErrors = false;
				}
			}
			
			this.saveData(false);
		},
		async saveData(changeFull = true) {
			if (changeFull) {
				this.fullErrors = false;
			}
			
			this.$nextTick(async () => {
				if (!this.isDataUpdating) {
					const valid = await this.$refs.clientForm.validate();
					if (Object.keys(valid.errors).length > 0) {
						this.competition.stage = '';
						if (document.getElementById("competition_form")) {
							document.getElementById("competition_form").scrollIntoView();
						}
						return;
					}
					
					this.isDataUpdating = true;
					const competition = this.competition;
					
					let cats = [];
					competition.categories.forEach((category) => {
						cats.push('/api/categories/' + category.id)
					});
					competition.categories = cats;
					
					let landing_infos = [];
					competition.expertLandingInfos.forEach((info) => {
						landing_infos.push('/api/expert_landing_infos/' + info.id)
					})
					competition.expertLandingInfos = landing_infos;
					
					
					competition.avatar = competition.clearAvatar;
					//console.log(competition);
					
					competition.user = '/api/users/' + competition.user.id;
					
					competition.reglamentPdf = competition.reglamentPdf.replace('competition/', '');
					
					axios.patch('/api/competitions/' + competition.id,
						this.competition,
						{
							headers: {
								'Accept': 'application/json',
								'Content-Type': 'application/merge-patch+json',
							}
						}
					).then((response) => {
						if (response.headers['content-type'] === 'text/html; charset=UTF-8') {
							alert('Время соединения истекло. Войдите повторно в свой аккаунт.');
							window.location.reload();
						}
						this.getData()
					}).catch(error => {
						console.log(error);
						alert('Ошибка получения данных')
					});
				}
			});
		},
		isVideo(fileName) {
			const extension = fileName.split('.').pop().toLowerCase();
			return extension === 'mp4';
		},
		addButton() {
			this.competition.buttons.push({
				'button_name': '',
				'button_link': ''
			});
		},
		addRecomendation() {
			if (!this.competition?.competitionData?.recomendations) {
				this.competition.competitionData.recomendations = [];
			}
			this.competition.competitionData.recomendations.push({
				'button_name': '',
				'button_link': ''
			});
		},
		saveButtons() {
			
			axios.patch('/api/competitions/' + this.competition.id, JSON.stringify({buttons: this.buttons}), {
				headers: {
					'Content-Type': "application/merge-patch+json"
				}
			})
		},
		deleteItem(index) {
			this.competition.buttons = this.competition.buttons.filter(function (el, inner_index) {
				return inner_index != index;
			});
			this.saveData()
		},
		deleteRecomendation(index) {
			this.competition.competitionData.recomendations = this.competition.competitionData.recomendations.filter(function (el, inner_index) {
				return inner_index != index;
			});
			this.saveData()
		},
		addQuestionAnswer() {
			this.competition.questionAnswer.push({
				'question': this.question_text,
				'answer': this.answer_text
			});
			this.saveData()
		},
		saveQuestionAnswer() {
			if (this.isNumber(this.current_qa_id)) {
				this.competition.questionAnswer[this.current_qa_id].question = this.question_text;
				this.competition.questionAnswer[this.current_qa_id].answer = this.answer_text;
				this.saveData();
				this.question_text = '';
				this.answer_text = '';
				this.current_qa_id = '';
			}
		},
		edit_question(index) {
			let qa = this.competition.questionAnswer.find((el, inner_index) => {
				return inner_index === index
			});
			if (qa) {
				this.question_text = qa.question;
				this.answer_text = qa.answer;
				this.current_qa_id = index;
				var element = document.getElementById('faq_block');
				element.scrollIntoView({behavior: 'smooth'});
			}
		},
		remove_question(index) {
			this.competition.questionAnswer = this.competition.questionAnswer.filter(function (el, inner_index) {
				return inner_index != index;
			});
			this.saveData()
		},
		remove_expert_landing(id) {
			const self = this;
			axios
				.post('/competition/removeExpertLanding', {
					expertId: id
				})
				.then(response => {
					self.getData();
					// console.log(response.data);
					// $('#competition_form').submit();
				}).catch(error => {
				alert('Ошибка получения данных')
			})
		},
		getFieldNameByIndex(index) {
			let res = '';
			if (index === 'name') {
				res = 'Название конкурса';
			} else if (index === 'formats') {
				res = 'Форматы проектов';
			}
			else if (index === 'napravlenie') {
				res = 'Направление';
			}
			else if (index === 'categories') {
				res = 'Категории';
			} else if (index === 'beginDate') {
				res = 'Дата начала';
			} else if (index === 'endDate') {
				res = 'Дата окончания';
			} else if (index === 'projectRules') {
				res = 'Поля';
			} else if (index === 'has_vote_criteria') {
				res = 'Критерии оценки';
			}
			return res;
		},
		isNumber(value) {
			return typeof value === 'number';
		},
		get_uploaded_image_asset(path) {
			return ImageService.getCompetitionImagePath(path);
		},
		async deleteImage(type) {
			this.isDataUpdating = true;
			await axios.post('/deleteCompetitionImage/' + this.competition.id, null, {
				params: {
					type: type
				}
			})
			this.getData();
		}
	},
	computed: {
		competitionId() {
			return window.competitionId;
		},
		selectedProductObject() {
			if (this.selectedProduct && this.products.length > 0) {
				return this.products.find(product => product.id === this.selectedProduct);
			}
			return null;
		},
		isAdmin() {
			return window.isAdmin
		},
		has_vote_criteria() {
			let has = false;
			this.competition.categories.forEach((category) => {
				if (category.voteCriteria.length > 0) {
					has = true;
				}
			});
			return has;
		},
		isBussinessArea() {
			return this.competition?.competitionData?.is_bussines_area || this.competition?.competitionData?.is_bussines_area === 'true';
		},
		companies_list() {
			let res = [];
			
			if (this.competition?.competitionData?.film_companies && this.competition?.competitionData?.film_companies.length > 0) {
				this.competition.competitionData.film_companies.forEach((item) => {
					this.companies.forEach((company) => {
						if (company.id === item) {
							res.push(company)
						}
					})
				})
			}
			return res;
		}
	}
}
</script>

<template>
  <div v-if="competition">
    <SaveInfo
        :isDataUpdating="isDataUpdating"
    ></SaveInfo>

    <div class="content-tab" style="display:block; padding: 0">

      <div style="margin: 30px 0">
        <h3 class="competition_name">{{ competition.name }}</h3>
        <div style="margin-top: 15px; color: #999" v-if="isAdmin">{{ competition.user.username }}</div>
      </div>
	    
	    <template v-if="competition.id == '143'">
		    <CompetitionUploadPriceTable />
	    </template>
	    

      <Form ref="clientForm" id="competition_form" v-slot="{errors}">
        <div class="errors-block"
             v-if="Object.keys(errors).length > 0">
          <b>Пожалуйста, заполните поля:</b>
          <ul>
            <li v-for="(error,index) in errors" :key="index">Поле "{{ getFieldNameByIndex(index) }}"
              обязательно для заполнения
            </li>
          </ul>
        </div>

        <Field style="display: none" v-model="competition.name" name="name"
               :rules="isRequired"></Field>
        <Field style="display: none" v-model="competition.napravlenie" name="napravlenie"
               :rules="isRequired"></Field>
        <Field style="display: none" v-model="competition.formats" v-if="fullErrors" name="formats"
               :rules="isRequired"></Field>
        <Field style="display: none" v-model="competition.categories" v-if="fullErrors" name="categories"
               :rules="isRequired"></Field>
        <Field style="display: none" v-model="competition.beginDate" v-if="fullErrors" name="beginDate"
               :rules="isRequired"></Field>
        <Field style="display: none" v-model="competition.endDate" v-if="fullErrors" name="endDate"
               :rules="isRequired"></Field>

<!--        <Field style="display: none" v-model="competition.projectRules" v-if="fullErrors" name="projectRules"-->
<!--               :rules="isRequired"></Field>-->

        <Field style="display: none" v-model="has_vote_criteria" v-if="fullErrors" name="has_vote_criteria"
               :rules="isRequired"></Field>


        <div class="tab_block">
          <p class="tab_block_title">Общая информация</p>
          <div class="tab_block_inner">
            <div class="columns">
              <div class="column left_column">
                <BaseInput
                    label="Название конкурса"
                    :is-required="true"
                    v-model="competition.name"
                    :isDataUpdated="isDataUpdating"
                    @onChange="saveData"
                ></BaseInput>

                <BaseInput
                    label="Короткое название конкурса (для слайдера)"
                    v-model="competition.shortName"
                    :isDataUpdated="isDataUpdating"
                    @onChange="saveData"
                ></BaseInput>

                <Textarea
                    label="Организаторы"
                    v-model="competition.organizator"
                    :isDataUpdated="isDataUpdating"
                    @onChange="saveData"
                >
														</Textarea>

                <div class="field">
                  <label class="req">Направление</label>
                  <p>Для не стандартных конкурсов с особой анкетой, вроде РВВБ выбираем "Конкурс проектов"</p>
                  <div class="select-field">
                    <select id="competition_napravlenie" :disabled="isDataUpdating" @change="saveData"
                            v-model="competition.napravlenie">
                      <option value="-">-</option>
                      <option value="Сценарный конкурс" selected="selected">Сценарный конкурс</option>
                      <option value="Конкурс видероликов">Конкурс видероликов</option>
                      <option value="Кинофестиваль">Кинофестиваль</option>
                      <option value="Конкурс проектов">Конкурс проектов</option>
                      <option value="Конкурс стартапов">Конкурс стартапов</option>
                      <option value="Бизнес площадка">Бизнес площадка</option>
                    </select>
                  </div>
                </div>

                <div class="field">
                  <label>Статус мероприятия</label>
                  <div class="select-field">
                    <select id="competition_stage" name="competition[stage]"
                            v-model="competition.stage" :disabled="isDataUpdating" @change="onStageChange">
                      <option value="Прием заявок" selected="selected">Прием заявок</option>
                      <option value="Обработка заявок">Обработка заявок</option>
                      <option value="Обработка заявок с редактированием">Обработка заявок с
                        редактированием
                      </option>
                      <option value="Завершен">Завершен</option>
                    </select>
                  </div>
                </div>
	              
	              <div style="margin-top: 30px;">
		              <h3 class="tab_block_title">Товар</h3>
		              <div style="margin-top: 30px;">
			              <Select
				              v-model:value="selectedProduct"
				              size="middle"
				              :filter-option="false"
				              style="width: 400px"
				              show-search
				              placeholder="Выберите товар"
				              @change="selectProduct"
			              >
				              <SelectOption value="">Не выбран</SelectOption>
				              <SelectOption v-for="(option, index) in products" :label="option.name" :value="option.id"
				                            :key="index">
					              {{ option.name }} ({{ option.price }} руб.)
				              </SelectOption>
			              </Select>
		              </div>
		              
		              <div style="margin-top: 15px;" v-if="selectedProductObject">
			              <p><strong>Выбранный товар:</strong> {{ selectedProductObject.name }} - {{ selectedProductObject.price }} руб.</p>
			              <div v-if="selectedProductObject.description">
				              <p><strong>Описание:</strong> {{ selectedProductObject.description }}</p>
			              </div>
		              </div>
	              </div>

<!--                <div class="field">-->
<!--                  <label>Тип конкурса</label>-->
<!--                  <div class="select-field">-->
<!--                    <select id="competition_type" name="competition[type]"-->
<!--                            v-model="competition.type" :disabled="isDataUpdating" @change="saveData">-->
<!--                      <option value="" selected="selected">Простой</option>-->
<!--                      <option value="Фестиваль">Фестиваль</option>-->
<!--                    </select>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="field checkbox_wrapper">-->
<!--                  <label for="competition_hideOrderButton" class="required">Скрыть кнопку подать-->
<!--                    заявку</label>-->
<!--                  <input @change="saveData" type="checkbox" v-model="competition.hideOrderButton"-->
<!--                         id="competition_hideOrderButton" name="competition[hideOrderButton]"-->
<!--                         required="required" value="1">-->
<!--                </div>-->

                <div class="field">
                  <Checkbox
                      v-model:checked="competition.hideOrderButton"
                      @change="saveData"
                  >Скрыть кнопку подать заявку
                  </Checkbox>
                </div>
	              
	              <div class="field">
		              <Checkbox
			              v-model:checked="competition.competitionData.leadToProject"
			              @change="saveData"
		              >Кнопка подать заявку напрямую в новый проект
		              </Checkbox>
	              </div>

                <div class="field">
                  <Checkbox
                      v-model:checked="competition.competitionData.isClose"
                      @change="saveData"
                  >Закрытый конкурс
                  </Checkbox>
                </div>
	              

                <p><strong>Сроки приема заявок</strong></p>

                <DataInputSimple
                    label="Дата начала"
                    :isDataUpdated="isDataUpdating"
                    v-model="competition.beginDate"
                    @onChange="saveData"
                ></DataInputSimple>

                <DataInputSimple
                    label="Дата окончания"
                    :isDataUpdated="isDataUpdating"
                    v-model="competition.endDate"
                    @onChange="saveData"
                ></DataInputSimple>

                <p><strong>Возраст участника для подачи заявок</strong></p>

                <BaseInput
                    label="Минимальный возраст"
                    v-model="competition.competitionData.min_age"
                    :isDataUpdated="isDataUpdating"
                    @onChange="saveData"
                ></BaseInput>

                <BaseInput
                    label="Максимальный возраст"
                    v-model="competition.competitionData.max_age"
                    :isDataUpdated="isDataUpdating"
                    @onChange="saveData"
                ></BaseInput>

                <div class="field">
                    <Textarea
                        label="Текст для всплывающего окна с пояснением об ограничениях возраста для подачи заявок"
                        v-model="competition.competitionData.age_description"
                        :isDataUpdated="isDataUpdating"
                        @onChange="saveData"
                    />
                </div>


              </div>
              <div class="column">
                <div v-if="competition.clearAvatar">
                  <ImageRender
                      :src="get_uploaded_image_asset(competition.avatar)"
                      class-name="competition_image"
                      :id="'image'"
                  ></ImageRender>


                  <!--                                    <img :src="'/uploads/images/competition/' + competition.clearAvatar" id="image">-->
                </div>
                <vue-cropper
                    ref="cropper"
                    :src="imgSrc"
                    alt="Source Image"
                    :aspect-ratio="570/360"
                    preview=".preview"
                    v-if="imgSrc != ''"
                >
                </vue-cropper>
                <button class="button2" @click.prevent="cropImage" v-if="imgSrc != ''"
                        style="margin-right: 40px;">
                  Сохранить изображение
                </button>

                <div class="field">
                  <label for="project_afisha">Аватар</label>
                  <i class="fas fa-download"></i>
                  <input :disabled="isDataUpdating" type="file" accept="image/*" id="project_afisha"
                         name="project[afisha]" @change="setImage">
                  <div id="fileList"></div>
                </div>

                <div v-if="competition.imageBig" style="margin-bottom: 30px;">
                  <template v-if="isVideo(competition.imageBig)">
                    <!--                                        <video controls autoplay :src="'/uploads/images/competition/' + competition.imageBig" id="video"></video>-->
                    <VideoRender
                        :id="'video'"
                        :src="'/uploads/images/competition/' + competition.imageBig"
                    ></VideoRender>
                  </template>
                  <template v-else>
                    <!--                                        <img :src="'/uploads/images/competition/' + competition.imageBig" id="image">-->
                    <ImageRender
                        :id="'image'"
                        :src="get_uploaded_image_asset('competition/'+competition.imageBig)"
                    ></ImageRender>
                  </template>

                  <p v-if="competition.imageBig"><a @click.prevent="deleteImage('imageBig')">Удалить</a></p>
                </div>
                <vue-cropper
                    ref="cropperBig"
                    :src="imgSrcBig"
                    alt="Source Image"
                    :aspect-ratio="2480/1395"
                    preview=".preview"
                    v-if="imgSrcBig != ''"
                >
                </vue-cropper>
                <button class="button2" @click.prevent="cropImageBig" v-if="imgSrcBig != ''"
                        style="margin-right: 40px; margin-top: 20px;">
                  Сохранить изображение
                </button>

                <div class="field">
                  <label for="project_afisha">Большое фоновое изображение или mp4 анимация</label>
                  <i class="fas fa-download"></i>
                  <input :disabled="isDataUpdating" type="file" accept="image/*,video/mp4" id="project_big_image"
                         name="project[big_image]" @change="setImageBig">
                  <div id="fileListBig"></div>


                </div>

                <div class="field">
                                    <Textarea
                                        label="Код для вставки видео конкурса"
                                        v-model="competition.competitionData.video_code"
                                        :isDataUpdated="isDataUpdating"
                                        @onChange="saveData"
                                    />
                </div>

                <div class="field">
                  <Checkbox
                      v-model:checked="competition.competitionData.is_bussines_area"
                      @change="saveData"
                  >Бизнес-площадка
                  </Checkbox>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="tab_block">
          <p class="tab_block_title">Описание конкурса</p>
          <div class="tab_block_inner">
            <div style="margin-bottom: 40px;">
              <div class="field">Слайды</div>

              <Upload
                  :action="'/competition/upload_competition_slide/'+competition.id"
                  @change="getData"
              >
                <Button>Загрузить</Button>
              </Upload>


              <div>
                <div v-for="(item, index) in competition?.competitionData?.slides" :key="index">
                  <div style="margin-top: 30px; margin-bottom: 30px;">
                    <p>
                      <ImageRender
                          :style="{ maxWidth: '500px' }"
                          :src="get_uploaded_image_asset('competition/'+item)"
                      ></ImageRender>
                      <!--																						<img style="max-width: 500px; " :src="'/uploads/images/competition/'+item" alt="">-->
                    </p>
                    <p><a @click="delete_competition_slide(item)">Удалить</a></p>
                  </div>

                </div>
              </div>

            </div>


            <TinymceEditor
                v-model="competition.beforeDescription"
                label="Блок перед описанием (без контейнера)"
                @onChange="saveData"
                :isDataUpdating="isDataUpdating"
                :is-required="true"
                @update="saveData"
            ></TinymceEditor>

            <TinymceEditor
                v-model="competition.description"
                label="Описание конкурса"
                @onChange="saveData"
                :isDataUpdating="isDataUpdating"
                :is-required="true"
                @update="saveData"
            ></TinymceEditor>
          </div>
        </div>

        <div class="tab_block">
          <p class="tab_block_title">Регламент</p>
          <div class="tab_block_inner">
            <BasePdfUploader
                label="Регламент"
                :value="competition.reglamentPdf"
                objectKey="reglamentPdf"
                :is-new-link="true"
                :pathToUpload="'/competition/uploadCompetitonReglament/'+competition.id"
                :pathToDelete="'/competition/removeCompetitonReglament/'+competition.id"
                @onChange="getData"
            ></BasePdfUploader>
          </div>
        </div>

        <div class="field">
          <label class="req" style="margin-bottom: 15px;">Форматы проектов</label>
          <div class="checkbox_wrapper" style="margin-bottom: 30px; display: block">
            <label style="display: block"><input @change="saveData" type="checkbox"
                                                 v-model="competition.formats" value="Короткометражное кино">
              <span style="margin-left: 15px">Короткометражное кино</span></label>
            <label style="display: block">
              <input type="checkbox" @change="saveData" v-model="competition.formats"
                     value="Полнометражное кино"><span
                style="margin-left: 15px">Полнометражное кино</span></label>
            <label style="display: block"><input @change="saveData" v-model="competition.formats"
                                                 type="checkbox" value="Сериал"><span
                style="margin-left: 15px">Сериал</span></label>
            <label style="display: block"><input @change="saveData" v-model="competition.formats"
                                                 type="checkbox" value="Веб-сериал"><span
                style="margin-left: 15px">Веб-сериал</span></label>
            <label style="display: block"><input @change="saveData" v-model="competition.formats"
                                                 type="checkbox" value="Документальное кино"><span
                style="margin-left: 15px">Документальное кино</span></label>
          </div>
        </div>

        <div>
          <p><strong>Полезные ссылки</strong></p>
          <div :key="index" v-for="(button, index) in competition.buttons">
            <div class="adds_button_wrapper">
              <div class="adds_button_item">
                                            <span @click="deleteItem(index)"
                                                  style="cursor: pointer; display: inline-block;"><i
                                                class="far fa-trash-alt"></i></span>
              </div>
              <div class="field">
                <label class="" for="project_fprk_name">Текст ссылки</label>
                <input @change="saveData" :disabled="isDataUpdating" type="text" :name="'button_name'+index"
                       v-model="button.button_name">
              </div>
              <div class="field">
                <label class="" for="project_fprk_name">Адрес ссылки</label>
                <input @change="saveData" :disabled="isDataUpdating" type="text" :name="'button_link'+index"
                       v-model="button.button_link">
              </div>
            </div>
          </div>
          <p style="margin-top: 30px; margin-bottom: 30px;">
            <Button @click.prevent="addButton">Добавить</Button>
          </p>

          <p><strong>Рекомендации</strong></p>
          <div :key="index" v-for="(button, index) in competition?.competitionData?.recomendations">
            <div class="adds_button_wrapper">
              <div class="adds_button_item">
                                            <span @click="deleteRecomendation(index)"
                                                  style="cursor: pointer; display: inline-block;"><i
                                                class="far fa-trash-alt"></i></span>
              </div>
              <div class="field">
                <label class="" for="project_fprk_name">Текст ссылки</label>
                <input @change="saveData" :disabled="isDataUpdating" type="text" :name="'button_name'+index"
                       v-model="button.button_name">
              </div>
              <div class="field">
                <label class="" for="project_fprk_name">Адрес ссылки</label>
                <input @change="saveData" :disabled="isDataUpdating" type="text" :name="'button_link'+index"
                       v-model="button.button_link">
              </div>
            </div>
          </div>
          <p style="margin-top: 30px; margin-bottom: 30px;">
            <Button @click.prevent="addRecomendation">Добавить</Button>
          </p>
        </div>
        <div class="tab_block">
          <p class="tab_block_title">Вопросы и ответы</p>
          <div class="tab_block_inner">
            <TinymceEditor
                v-model="competition.faq"
                :isDataUpdating="isDataUpdating"
                label="Вопросы и ответы"
                :is-required="true"
                @update="saveData"
                @onChange="saveData"
            ></TinymceEditor>

            <div id="faq_block">
              <div class="field">
                <label for="question_text">Текст вопроса</label>
                <input type="text" id="question_text" name="question_text" v-model="question_text">
              </div>
              <TinymceEditor
                  v-model="answer_text"
                  label="Текст ответа"
                  :isDataUpdating="isDataUpdating"
              ></TinymceEditor>
              <!--                            <div class="field">-->
              <!--                                <label for="answer_text">Текст ответа</label>-->
              <!--                                <textarea id="answer_text" name="answer_text" v-model="answer_text"></textarea>-->
              <!--                            </div>-->
            </div>

            <p v-if="!isNumber(current_qa_id)" style="margin-top: 20px;">
              <Button @click="addQuestionAnswer">Добавить вопрос-ответ</Button>
            </p>
            <p v-else style="margin-top: 20px;">
              <Button @click="saveQuestionAnswer">Сохранить вопрос-ответ</Button>
            </p>


            <p style="margin-top: 30px;"><strong>Список добавленных вопросов</strong></p>
            <div class="list_questions">
              <table>
                <tr>
                  <td>Название</td>
                  <td>Действие</td>
                </tr>
                <tr :key="index" v-for="(questionAnswer, index) in competition.questionAnswer">
                  <td>{{ questionAnswer.question }}</td>
                  <td>
                    <p><a
                        @click="edit_question(index)">Редактировать вопрос</a></p>
                    <p><a class="remove_question"
                          @click="remove_question(index)">Удалить вопрос</a></p>
                  </td>
                </tr>
                <!--                            {% for questionAnswer in competition.questionAnswer|sort((a, b) => a.position|default(0) <=> b.position|default(0)) %}-->
                <!--                            -->
                <!--                            {% endfor %}-->
              </table>
            </div>


          </div>
        </div>

        <div class="tab_block">
          <p class="tab_block_title">Эксперты для описания конкурса</p>
          <div class="tab_block_inner">
            <div class="columns">
              <div class="column is-half">
                <div v-if="imgSrcExpert === ''" id="expert_image_container">
                  <img id="expert_image" src="/images/anonym.png">
                </div>

                <vue-cropper
                    ref="cropper_expert"
                    :src="imgSrcExpert"
                    alt="Source Image"
                    :aspect-ratio="500 / 500"
                    preview=".preview"
                    v-if="imgSrcExpert != ''"
                >
                </vue-cropper>


                <div class="field">
                  <label for="expert[avatar]">Изображение эксперта</label>
                  <i class="fas fa-download"></i>
                  <input :disabled="isDataUpdating" type="file" accept="image/*" id="expert[avatar]"
                         name="expert[avatar]" @change="setImageExpert">
                  <div id="fileListExpert"></div>
                </div>

                <div class="field">
                  <label for="expert_fio">ФИО эксперта</label>
                  <span class="error_label" id="expert_fio_error"></span>
                  <input type="text" id="expert_fio" name="expert_fio" v-model="expert_fio"
                         maxlength="255"
                  >
                </div>

                <div class="field">
                  <label for="expert_dolzhnost">Должность эксперта</label>
                  <span class="error_label" id="expert_dolzhnost_error"></span>
                  <input type="text" id="expert_dolzhnost" name="expert_dolzhnost"
                         maxlength="255" v-model="expert_dolzhnost">
                </div>
                <p class="image_button_expert">
                  <Button @click="saveExpert()">Добавить эксперта</Button>
                </p>
              </div>
            </div>
            <div class="columns list_experts">
              <div :key="index" v-for="(item, index) in competition.expertLandingInfos" class="column is-3">
                <div>
                  <p class="expertLandingAvatar_wrapper">
                    <!--                                        <img-->
                    <!--                                                class="expertLandingAvatar"-->
                    <!--                                                :src="'/uploads/images/competition/'+item.clearPhoto"-->
                    <!--                                        >-->

                    <ImageRender
                        class-name="expertLandingAvatar"
                        :src="get_uploaded_image_asset('competition/'+item.clearPhoto)"
                    ></ImageRender>
                  </p>
                  <p class="expert_fio_text">{{ item.fio }}</p>
                  <p class="expert_fio_dolzhnost">{{ item.dolzhnost }}</p>
                </div>

                <p style="margin-top: 30px; text-align: center"><a
                    :href="'/competition/editExpertLanding/' + item.id">Редактировать</a>
                </p>
                <p style="text-align: center"><span @click="remove_expert_landing(item.id)"
                                                    class="remove_expert_landing">Удалить</span>
                </p>
              </div>

            </div>

          </div>
        </div>

        <div class="tab_block">
          <h3 class="tab_block_title">Категории конкурса</h3>

          <p style="margin-top: 30px;"><strong>Список категорий</strong></p>

          <table class="table">
            <thead>
            <tr>
              <th>Название</th>
              <th>Действия</th>
            </tr>
            </thead>
            <tbody>
            <template v-if="competition.categories.length > 0">
              <tr :key="index" v-for="(category, index) in competition.categories">
                <td>{{ category.name }}</td>
                <td>
                  <a style="margin-right: 40px;" :href="'/category/edit/'+category.id"><i
                      class="far fa-edit"></i></a>
                  <a style="margin-right: 40px;" class="delete_link" :href="'/category/delete/'+category.id"><i
                      class="far fa-trash-alt"></i></a>
                  <a :href="'/criterion/new/'+category.id" target="_blank">Критерии оценки</a>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="3">Записей нет</td>
              </tr>
            </template>

            <!--                    {% for category in competition.categories %}-->
            <!--										{% else %}-->

            <!--										{% endfor %}-->
            </tbody>
          </table>

          <a :href="'/category/new/'+competition.id">Добавить</a>
        </div>

        <div style="margin-top: 30px;">
          <h3 class="tab_block_title">Кинокомпании</h3>
          <div style="margin-top: 30px;">
            <Select
                v-model:value="company"
                size="middle"
                :filter-option="false"
                style="width: 400px"
                show-search
            >
              <SelectOption v-for="(option, index) in companies" :label="option.firm_name" :value="option.id"
                            :key="index">
                {{ option.firm_name }}
              </SelectOption>
            </Select>

            <Button style="margin-left: 20px;" @click="addCompany">Добавить</Button>
          </div>

          <div style="margin-top: 30px;">
            <Table
                v-if="companies_list.length > 0"
                :data-source="companies_list"
                :columns="company_columns"
                :loading="loading"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'action'">
                  <a @click="deleteCompanyItem(record.id)">Удалить</a>
                </template>
              </template>
            </Table>
            <div v-else>Ничего не добавлено</div>
          </div>
        </div>
      </Form>
	    
	    <div class="export_competition">
		    <ExportCompetition
			    v-if="competition"
			    :competition="competition"
		    />
	    </div>
    </div>
  </div>
  <div v-else>
    <div style="padding: 30px; display: flex; align-items: center; justify-content: center">
      <Spin></Spin>
    </div>
  </div>
</template>

<style>
.adds_button_wrapper {
    border: 1px solid #ccc;
    padding: 20px;
    margin-top: 30px;
    position: relative;
}

.adds_button_item {
    position: absolute;
    right: 10px;
    top: 10px
}

.adds_button_wrapper .field {
    margin-top: 0;
    margin-bottom: 15px;
}

.adds_button_wrapper .field:last-child {
    margin-bottom: 0;
}
#competition_form {
	padding-top: 0;
}

</style>